import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs as MuiBreadcrumbs, Link as MuiLink, Typography, } from '@mui/material';
import { NavigateNextIcon } from '../icons';
/**
 * Site breadcrumbs.
 *
 * Renders the trail passed in `items`; earlier crumbs are links, the last is
 * plain text marked `aria-current="page"`.
 *
 * @example
 * ```tsx
 * <Breadcrumbs
 *   items={[
 *     { label: 'Products', to: '/products' },
 *     { label: product?.name ?? 'Loading…' },
 *   ]}
 * />
 * ```
 */
export function Breadcrumbs({ items, linkComponent, ariaLabel = 'breadcrumb', separator, }) {
    if (items.length === 0)
        return null;
    return (_jsx(MuiBreadcrumbs, { "aria-label": ariaLabel, separator: separator ?? _jsx(NavigateNextIcon, { fontSize: "small" }), sx: {
            '& .MuiBreadcrumbs-ol': { flexWrap: 'wrap', rowGap: 0.5 },
            fontSize: '0.875rem',
        }, children: items.map((item, index) => {
            const isLast = index === items.length - 1;
            if (isLast || !item.to) {
                return (_jsx(Typography, { color: "text.primary", variant: "body2", "aria-current": isLast ? 'page' : undefined, sx: { fontWeight: isLast ? 600 : 400 }, children: item.label }, `${item.label}-${index}`));
            }
            return (_jsx(MuiLink, { ...(linkComponent
                    ? { component: linkComponent, to: item.to }
                    : { href: item.to }), underline: "hover", color: "text.secondary", variant: "body2", children: item.label }, `${item.label}-${index}`));
        }) }));
}
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map